// extracted by mini-css-extract-plugin
export default {"subtitle_text":"Oil_subtitle_text__kAZC9","subtitle_text_highlight":"Oil_subtitle_text_highlight__Kth+q","subtitle_container":"Oil_subtitle_container__eFrGT text-center"};